// theme constant
export const gridSpacing = 3
export const drawerWidth = 264
export const appDrawerWidth = 350
export const LOCAL_SPACE_ID = 'spaceId'
export const CONFIG = 'config';
